import { useOnScreen } from "hooks/onScreen";
import React, { useEffect, useRef, useState } from "react";
import "./Card.scss";

interface CardProps {
  title: string;
  des: string;
  img: string;
  isImgLeft?: boolean;
  icon?: string;
}

export const Card: React.FC<CardProps> = ({
  title,
  des,
  img,
  isImgLeft,
}) => {
  const cardRef = useRef<HTMLDivElement>(null);
  const titleRef = useRef<HTMLDivElement>(null);
  const desRef = useRef<HTMLDivElement>(null);
  const isInview = useOnScreen(cardRef);
  const [needAnimate, setNeedAnimate] = useState(false);
  useEffect(() => {
    if (titleRef.current) {
      titleRef.current.innerHTML = title;
    }
    if (desRef.current) {
      desRef.current.innerHTML = des;
    }
  }, [title, des]);
  useEffect(() => {
    if (isInview) {
      setNeedAnimate(isInview);
    }
  }, [isInview]);
  return (
    <div ref={cardRef} className="container app-card">
      <div
        className={`row ${isImgLeft ? "img-left-layout" : ""} card-container`}
      >
        <div className="col text-container">
          <h1 className="title">
            <strong ref={titleRef}></strong>
          </h1>
          <div ref={desRef} className="des" />
        </div>
        <div className="col card-img-frame">
          <div className=" card-img">
            <div className={`img-frame ${needAnimate ? "img-animate" : ""}`}>
              <img src={img} alt="" />
            </div>
          </div>
          {/* <div className="ic-center">
            <img src={icon} alt="center" />
          </div> */}
        </div>
      </div>
    </div>
  );
};
